import Store from "./Store";
import { IToken } from "@/module/user";

export default {
    setAccessToken(state: Store, val: IToken): void {
        state.token = val;
    },
    setEnv(state: Store, val: string): void {
        state.env = val;
    },
    setEnvType(state: Store, val: string): void {
        state.envType = val;
    },
    setEnvBrand(state: Store, val: string): void {
        state.envBrand = val;
    },
    setFinancedSubjectType(state: Store, val: string): void {
        state.financedSubjectType = val;
    },
    setClientType(state: Store, val: string): void {
        state.clientType = val;
    },
    setOrderType(state: Store, val: string): void {
        state.orderType = val;
    },
    setFinancingType(state: Store, val: string): void {
        state.financingType = val;
    },
    setCashFinancingType(state: Store, val: string): void {
        state.cashFinancingType = val;
    },
    setShowQrCode(state: Store, val: boolean): void {
        state.showQrCode = val;
    },
    setCopyToClipboard(state: Store, val: boolean): void {
        state.copyToClipboard = val;
    },
    setWalletWithOrder(state: Store, val: string): void {
        state.walletWithOrder = val;
    },
    setFinancingApiVersion(state: Store, val: string): void {
        state.financingApiVersion = val;
    },
    setCarLoanType(state: Store, val: string): void {
        state.carLoanType = val;
    },
};
